import { render } from "./AnimalInactiveDetail.vue?vue&type=template&id=3e8562fe&scoped=true"
import script from "./AnimalInactiveDetail.vue?vue&type=script&lang=js"
export * from "./AnimalInactiveDetail.vue?vue&type=script&lang=js"

import "./AnimalInactiveDetail.vue?vue&type=style&index=0&id=3e8562fe&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8562fe"]])

export default __exports__